import { MdNotifications } from "react-icons/md"
import { AiOutlineGlobal} from 'react-icons/ai';

export const ExploreApi =[
    {
        titel:"India travel guide",
        to:"/"
    },
    {
        titel:"Hotels in India",
        to:"/"
    },
    {
        titel:"Holiday rentals in India",
        to:"/"
    },
    {
        titel:"Holiday oackages in India",
        to:"/"
    },
    {
        titel:"Domestic flights",
        to:"/"
    },
    {
        titel:"Car hire in India",
        to:"/"
    },
    {
        titel:"All accommodation types",
        to:"/"
    },
    {
        titel:"Travel blog",
        to:"/"
    },
  ]
  export const HelpApi =[
    {
        titel:"Support",
        to:"/"
    },
    {
        titel:"Change or cancel your booking",
        to:"/"
    },
    {
        titel:"refund process and timelines",
        to:"/"
    },
    {
        titel:"Book aflight using an airline credit",
        to:"/"
    },
    {
        titel:"International travel documents",
        to:"/"
    }]
    export const CompanyApi =[
        {
            titel:"About us",
            to:"/"
        },
        {
            titel:"Jobs",
            to:"/"
        },
        {
            titel:"List your property",
            to:"/"
        },
        {
            titel:"Partnerships",
            to:"/"
        }]
        export const PolicyApi =[
            {
                titel:"Privacy Statement",
                to:"/"
            },
            {
                titel:"terms of use",
                to:"/"
            },
            {
                titel:"vrbo terms and conditions",
                to:"/"
            }]
export const MobileNavItemApi=[
    {
        titel:"Stays",
        to:"/stays",
        icon:"<RiHotelFill/>"
    },
    {
        titel:"Flights",
        to:"/flights",
        icon:"MdOutlineFlight"

    },
    {
        titel:"Cars",
        to:"/cars",
        icon:"IoCarSportSharp"
    },
    {
        titel:"Packages",
        to:"/pacakages",
        icon:"VscCombine"
    },
    {
        titel:"Things to do",
        to:"/things-to-do",
        icon:"IoTicketSharp"
    },
    {
        titel:"Cruies",
        to:"/cruises",
        icon:"RiShipFill"
    }
]
export const RouteApi=[
    { id:"Ri1",
        titel:<AiOutlineGlobal/> ,
        text:"English",
        to: "/",
    },
    {id:"Ri2",
        titel:"Listyour property",
        to:"/listyour-property",
    },
    {id:"Ri3",
        titel:"Support",
        to:"/support",
    },
    {id:"Ri4",
        titel:"Trips",
        to:"/sign-in",
    },
    {id:"Ri5",
        titel:<MdNotifications/>,
        to:"/",
    },

]